/**
 * Reine Hilfsfunktionen/Typen für die neuen Tipp-Kategorien (Tor/Assist/Zuschauer).
 * Bewusst von den React-Komponenten getrennt (Fast-Refresh / react-refresh).
 */

/** Eingabe-Drafts pro Spiel für Tor- und Assist-Tipp. */
export interface PlayerDraft {
  /** player_id als String; '' = nicht gewählt; 'none' = „keiner" (NULL). */
  scorer: string;
  assist: string;
}

/** Zuschauer-Draft (interval_index als String; '' = nicht gewählt). */
export interface AttendanceDraft {
  interval: string;
}

/** Select-Wert für „keiner" (player_id NULL). */
export const NONE_VALUE = 'none';

/** Wandelt einen PlayerSelect-Wert in den API-Body-Wert (number|null) um. */
export function playerValueToId(value: string): number | null {
  if (value === NONE_VALUE) return null;
  if (value === '') return null;
  return Number(value);
}
